import { List, Paragraph, Text } from '@zillow/constellation-10';

const IdVerificationContent = () => (
  <>
    <Paragraph css={{ marginBottom: '400' }}>
      To protect applicants&apos; confidential information, we&apos;ll need to verify your identity before you can view
      applications.
    </Paragraph>
    <Paragraph>Applications include each renter&apos;s:</Paragraph>
    <List.Root css={{ marginBottom: '400', fontSize: 'body-xs' }}>
      <List.Item css={{ paddingBlock: 0 }}>
        <Text>Comprehensive credit report</Text>
      </List.Item>
      <List.Item css={{ paddingBlock: 0 }}>
        <Text>Background check</Text>
      </List.Item>
      <List.Item css={{ paddingBlock: 0 }}>
        <Text>Income documents (if provided)</Text>
      </List.Item>
    </List.Root>
    <Paragraph>
      Once completed, your ID verification will be valid for <Text textStyle="body-bold">335 days.</Text>
    </Paragraph>
  </>
);

export default IdVerificationContent;
